// react
import { Suspense } from 'react';

// tanstack
import { useParams } from '@tanstack/react-router';

// material ui
import { CircularProgress } from '@mui/material';

// api
import { useGetEnergyGroupQuery } from '@/api/generated/recalc/endpoints/v2/energyGroups';

// shared components
import PageContainer from '@/components/layout/PageContainer';

// feature-components
import StandardAnalysisDatagrid from '@/features/energyxplorer/components/standard-analysis/StandardAnalysisDatagrid';

// feature-utils
// components
import { useUrlDateRange } from '@/hooks/useUrlDateRange';

// relative
import { useGetStandardAnalysisQuery } from '../../../../api/energy-analysis/calculateEnergySavingsApiSlice';

const StandardAnalysisTab = () => {
  const { accountId, energyGroupId } = useParams({ strict: false });
  const { data: energyGroup } = useGetEnergyGroupQuery(
    { groupId: energyGroupId },
    { skip: !energyGroupId },
  );

  const { timeRange } = useUrlDateRange();

  //Query
  const { data, isFetching } = useGetStandardAnalysisQuery({
    accountId: accountId,
    energyGroupId: energyGroupId,
    start: timeRange?.start,
    end: timeRange?.end,
  });

  // Errors from standard analysis query are handled by apiErrorMiddleware.

  // useEffect(() => {
  //   if (data?.TimestampsSummary) {
  //     setTimestampSummary(data.TimestampsSummary);
  //     setTimestampSummarySetBy('Standardanalysen');
  //   }
  // }, [data, setTimestampSummary, setTimestampSummarySetBy]);

  // Helper function to build path from root to current node
  const buildNodePath = (nodeId, allNodes) => {
    const path = [];
    let currentNode = allNodes.find((n) => n.energyTreeNodeId === nodeId);

    while (currentNode) {
      // Use node ID to ensure uniqueness in the path
      path.unshift(currentNode.energyTreeNodeId);
      if (currentNode.parentId) {
        currentNode = allNodes.find(
          (n) => n.energyTreeNodeId === currentNode.parentId,
        );
      } else {
        currentNode = null;
      }
    }

    return path;
  };

  if (!energyGroup) return null;

  // const rootNode = energyGroup?.energyTreeNodes?.length
  //   ? getRootNode(energyGroup.energyTreeNodes)
  //   : null;

  return (
    <PageContainer sx={{ pt: 0 }}>
      <Suspense fallback={<CircularProgress />}>
        <StandardAnalysisDatagrid
          initialRows={
            data?.StandardAnalysisData?.map((item) => {
              const energyNode = energyGroup?.energyTreeNodes?.find(
                (group) => group.energyTreeNodeId === item.NodeId,
              );
              return {
                ...item,
                id: item.NodeId,
                Name: energyNode?.name,
                Type: energyNode?.type,
                icon: energyNode?.type,
                hierarchy: buildNodePath(
                  item.NodeId,
                  energyGroup?.energyTreeNodes || [],
                ),
              };
            }) || []
          }
          isLoading={isFetching}
          selectedEnergyGroup={energyGroup.options}
        />
      </Suspense>
    </PageContainer>
  );
};

export default StandardAnalysisTab;
